import { Clickable } from '@ahmdigital/ui';
import React from 'react';

import { scrollToElement } from '../ui';

const onClickFootnote = (footnoteId: string) => () => {
  scrollToElement(document.getElementById(footnoteId));
};

/* eslint-disable react/prop-types */
// @ts-expect-error - Automatic, Please fix when editing this file
const footnoteSerializer = (footnoteId: string, variant) => (props: { node: { text: string } }) => (
  <Clickable variant={variant} onClick={onClickFootnote(footnoteId)}>
    {props.node.text}
  </Clickable>
);
/* eslint-disable react/prop-types */

// @ts-expect-error - Automatic, Please fix when editing this file
const getFootnoteSerializer = ({ footnote, variant }) => {
  if (footnote) {
    return { footnote: footnoteSerializer(footnote.linkId, variant) };
  }

  return {};
};

export default getFootnoteSerializer;
